import { ThemeProvider } from "styled-components";
import valinorTheme from "./valinorTheme";
import GlobalStyle from "./GlobalStyle.styles";

const Theme = ({ children }) => (
  <ThemeProvider theme={valinorTheme}>
    <GlobalStyle />
    {children}
  </ThemeProvider>
);

export default Theme;
